<template>
    <div>
        <colapse label="Buttons">
            <div>
                <ColorSelector v-if="style.bt_fill!='empty'" label="Text" :colors='getColorsArray'
                    v-model="style.bt_text_color" />
                <ColorSelector label="Background" :colors='getColorsArray' v-model="style.bt_color" />
                <!-- <Slider label="Shadow"/> -->
                <label>Shape</label>
                <div class="demoContainer">
                    <b-button :class="`primary ${bt_shape}`" v-for="bt_shape in bt_shapes" v-bind:key="bt_shape"
                        @click="setBtnShape(bt_shape)">
                        {{bt_shape}}
                    </b-button>
                </div>

                <label>Style</label>
                <div class="demoContainer">
                    <b-button :class="`primary`" v-for="fill in bt_fill" v-bind:key="fill" @click="setBtnFill(fill)">
                        {{fill}}
                    </b-button>
                </div>
            </div>
        </colapse>
        <div class="manager">
            <colapse label="Profile Image">
                <Slider label="Image border" v-model="style.img_border" :max="30" />
                <ImageUploader @input="loadImage">
                </ImageUploader>
            </colapse>

            <colapse label="Background">
                <ColorSelector label="Background" :colors='getColorsArray' v-model="style.bg_color" />
            </colapse>

             <b-button class="primary" @click="saveStyle()">save style</b-button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import ColorSelector from '@/components/ColorSelector.vue'
    import Slider from '@/components/Slider.vue'
    import ImageUploader from '@/components/ImageUploader.vue'
    import Colapse from '@/components/containers/Colapse.vue'
    import API from "@/js/api"

    export default {
        data(){
            return{
                bt_shapes:[
                    "smooth",
                    "sharp"
                ],
                bt_fill:[
                    'filled',
                    'empty'
                ]
            }
        },
        components:{
            Colapse,
            ColorSelector,
            Slider,
            ImageUploader,
        },
        computed:{
            ...mapGetters([
                'style',
                'getColorsArray',
                'userName'
                ])
        },
        methods:{
            ...mapActions(['saveStyle']),
            ...mapMutations(['setImage',]),
            loadImage(data){
            this.setImage(data.localUrl);
            const formData = new FormData();
            formData.append('file', data.file);
            API.image.post(this.userName,formData) 
            
            },
        }
    }
</script>

<style>

</style>